var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pendo-poll-metrics-table',{attrs:{"guide":_vm.guide,"polls":_vm.polls,"views":_vm.views,"views-agg-status":_vm.viewsAggStatus,"response-count":_vm.responseCount,"response-count-agg-status":_vm.responseCountAggStatus},on:{"poll-link-click":_vm.onPollLinkClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }